export const PRODUCT_NAME = "orderbooster";

export const TARGET_ORDER_CNT = 30;

// export const TEST_USER_NAME_LIST = ["13077840001", "13000010001", "13077840002"];

export const PAYMENT_METHOOD = "PAYMENT_METHOD_TYPE_ALI_PAY";
